import { render, staticRenderFns } from "./box-shadow.vue?vue&type=template&id=22eca4fc&scoped=true&"
import script from "./box-shadow.vue?vue&type=script&lang=js&"
export * from "./box-shadow.vue?vue&type=script&lang=js&"
import style0 from "./box-shadow.vue?vue&type=style&index=0&id=22eca4fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eca4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22eca4fc')) {
      api.createRecord('22eca4fc', component.options)
    } else {
      api.reload('22eca4fc', component.options)
    }
    module.hot.accept("./box-shadow.vue?vue&type=template&id=22eca4fc&scoped=true&", function () {
      api.rerender('22eca4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common-page/country-proj/components/box-shadow.vue"
export default component.exports